import React from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { tabNameToTitle } from '../../../common/utils/api_utils';
import AdvanceAppConstant from '../../app-setting/AdvanceAppConstant';
import CustomComponentMenu from '../../app-setting/CustomComponentMenu';
import CustomCSSJSMenu from '../../app-setting/CustomCSSJSMenu';
import SnapshotMenu from '../../app-setting/SnapshotMenu';
import ActivityMenu from '../../app-setting/ActivityMenu';
import AIModelMenu from '../../app-setting/AIModelMenu';
export const AppSettingsNav = ({ activeTab, projectDetail }) => {
  return (
    <nav className="navbar navbar-expand-lg bg-primary">
      <div className="container">
        <div className="navbar-translate">
          <div className="navbar-brand">
            <i className={`wb ${drapcodeIcon(activeTab)}`} size={'md'}></i>&nbsp;
            <span>{tabNameToTitle(activeTab)}</span>
          </div>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li>
              <AdvanceAppConstant projectDetail={projectDetail} />
            </li>
            <li>
              <CustomComponentMenu />
            </li>
            <li>
              <CustomCSSJSMenu />
            </li>
            <li>
              <AIModelMenu />
            </li>
            <li>
              <ActivityMenu />
            </li>
            <li>
              <SnapshotMenu />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
